import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import {
  getEvents,
  addNewEvent,
  updateEvent,
  deleteEvent,
  getCategories,
} from "../../helpers/fakebackend_helper"

// Async actions using createAsyncThunk
export const fetchEvents = createAsyncThunk(
  "calendar/fetchEvents",
  async () => {
    const response = await getEvents()
    return response
  }
)

export const addEvent = createAsyncThunk("calendar/addEvent", async (event) => {
  const response = await addNewEvent(event)
  return response
})

export const updateEventAction = createAsyncThunk(
  "calendar/updateEvent",
  async (event) => {
    const response = await updateEvent(event)
    return response
  }
)

export const deleteEventAction = createAsyncThunk(
  "calendar/deleteEvent",
  async (event) => {
    const response = await deleteEvent(event)
    return response
  }
)

export const fetchCategories = createAsyncThunk(
  "calendar/fetchCategories",
  async () => {
    const response = await getCategories()
    return response
  }
)

// Create the slice
const calendarSlice = createSlice({
  name: "calendar",
  initialState: {
    events: [],
    categories: [],
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Events
      .addCase(fetchEvents.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchEvents.fulfilled, (state, action) => {
        state.loading = false
        state.events = action.payload
      })
      .addCase(fetchEvents.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      // Add Event
      .addCase(addEvent.pending, (state) => {
        state.loading = true
      })
      .addCase(addEvent.fulfilled, (state, action) => {
        state.loading = false
        state.events.push(action.payload)
      })
      .addCase(addEvent.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      // Update Event
      .addCase(updateEventAction.pending, (state) => {
        state.loading = true
      })
      .addCase(updateEventAction.fulfilled, (state, action) => {
        state.loading = false
        state.events = state.events.map((event) =>
          event.id === action.payload.id ? action.payload : event
        )
      })
      .addCase(updateEventAction.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      // Delete Event
      .addCase(deleteEventAction.pending, (state) => {
        state.loading = true
      })
      .addCase(deleteEventAction.fulfilled, (state, action) => {
        state.loading = false
        state.events = state.events.filter(
          (event) => event.id !== action.payload.id
        )
      })
      .addCase(deleteEventAction.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      // Fetch Categories
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false
        state.categories = action.payload
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
  },
})

export default calendarSlice.reducer
